// extracted by mini-css-extract-plugin
export default {"container":"styles_container__5QfMc","text-container":"styles_text-container__X+4Aj"};